import React from "react";

/* A house — the About group in the edit-profile rail, and the shortcut back to
   the dashboard that floats over the form. */
export const HomeIcon = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       aria-hidden="true" focusable="false" className={className}>
    <path d="M3.5 10.6 12 3.8l8.5 6.8V20a.9.9 0 01-.9.9h-4.4v-6.2H9.8v6.2H5.4a.9.9 0 01-.9-.9v-9.4z"
          stroke="currentColor" strokeWidth="1.7"
          strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default HomeIcon;
